import { useEffect, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { isSoundMuted, setSoundMuted } from '@/lib/notification-sound';

export function SoundToggle() {
  const [muted, setMuted] = useState(isSoundMuted);

  useEffect(() => {
    const sync = () => setMuted(isSoundMuted());
    window.addEventListener('notification-sound-changed', sync);
    return () => window.removeEventListener('notification-sound-changed', sync);
  }, []);

  const toggle = () => {
    setSoundMuted(!muted);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={muted ? 'Unmute notifications' : 'Mute notifications'}
      title={muted ? 'Unmute notifications' : 'Mute notifications'}
    >
      {muted ? (
        <VolumeX className="h-5 w-5 text-muted-foreground" />
      ) : (
        <Volume2 className="h-5 w-5" />
      )}
    </Button>
  );
}
